import React from 'react'
import Header from '../Header/Header';
import Footer from '../Footer';

export type MainLayoutProps = {
  children: React.ReactNode
};

const MainLayout: React.FC<MainLayoutProps> = ({
  children
}) => {
  return (
    <div className='w-full flex flex-col'>
      <Header />
      <div id="content-container" style={{minHeight: 'calc(100vh - 100px)'}}>
        {children}
      </div>
      <Footer />
    </div>
  );
}

export default MainLayout;